import React from "react";
import Html from "./html";
import { Provider } from "./provider";

const RecallVisits = () => {
    return (
        <Provider>
            <Html/>
        </Provider>
    );
}

export default RecallVisits;